import React from 'react'

import { ChevronDown, ChevronRight } from 'lucide-react'
import { observer } from 'mobx-react'

// localization: no text to translate

interface IProps {
  isShown: boolean
  fieldCaption: string
  areValuesHidden: boolean
  actions?: JSX.Element

  toggleValuesHidden(): void
}

function WorkflowFormFieldHeader({
  isShown,
  fieldCaption,
  areValuesHidden,
  actions,
  toggleValuesHidden,
}: IProps) {
  if (!isShown) {
    return null
  }

  const ChevronIcon = areValuesHidden ? ChevronRight : ChevronDown

  return (
    <div className="tw:flex tw:items-center tw:h-10 tw:px-4 tw:bg-muted tw:select-none">
      <div
        className="tw:flex tw:items-center tw:flex-1 tw:min-w-0 tw:cursor-pointer tw:gap-2"
        onClick={toggleValuesHidden}
      >
        <ChevronIcon className="tw:size-5 tw:shrink-0 tw:text-foreground" />
        <span
          className="tw:text-body-md tw:font-semibold tw:text-foreground tw:truncate"
          title={fieldCaption}
        >
          {fieldCaption}
        </span>
      </div>
      {actions}
    </div>
  )
}

export default observer(WorkflowFormFieldHeader)
